import type { VisualGuideStepFront } from './graphql';

export const VISUAL_GUIDE_EVENTS = [
  'WelcomeMessageEdited',
  'WelcomeMessagesClosed',
  'PrintEditStarted',
  'PrintEditFinished',
  'DeliveryMethodCustomFieldAdded',
] as const;

export type VisualGuideEvents = typeof VISUAL_GUIDE_EVENTS[number];

export const isVisualGuideEvent = (
  value: unknown,
): value is VisualGuideEvents =>
  typeof value === 'string' &&
  VISUAL_GUIDE_EVENTS.some((event) => event === value);

export interface VisualGuideDialog {
  close(): void;
}

/** Server fields come from GraphQL; the remaining fields belong to a playback session. */
export interface VisualGuideStep
  extends Partial<
    Omit<
      VisualGuideStepFront,
      '__typename' | 'action' | 'actions' | 'pauseOnActions' | 'resumeOnActions'
    >
  > {
  action?: string;
  actions?: string[];
  pauseOnActions?: string[];
  resumeOnActions?: string[];
  actionDelay?: number;
  hideOverlay?: boolean;
  fullscreenMessage?: string;
  isOriginal?: boolean;
  visualGuideId?: string;
  currentWindowId?: number;
  isSubNav?: boolean;
  waitTimeoutOnGoingBack?: number;
  nodePosition?: { x: number; y: number };
  node?: HTMLElement;
  currentDialogWindow?: VisualGuideDialog;
}

export type VisualGuideSteps = VisualGuideStep[];

export function getVisualGuideActions(step: VisualGuideStep): string[] {
  return Array.isArray(step.actions)
    ? step.actions.filter(
        (action) => typeof action === 'string' && action.length > 0,
      )
    : typeof step.action === 'string' && step.action.length > 0
    ? [step.action]
    : [];
}
